import {defineAction} from 'redux-define';
import {createAction, handleActions} from 'redux-actions';
import get from 'lodash.get';

const namespace = 'flows/lead';

const PERSIST = defineAction('PERSIST', namespace);
export const persist = createAction(PERSIST.ACTION);

// Selectors
export const selectInviteSaving = store => get(store, 'flows.lead.invite.saving');

const initialState = {};
export const reducer = handleActions({
  [PERSIST.ACTION]: (state, action) => ({
    ...state,
    ...action.payload,
  }),
}, initialState);



// WEBPACK FOOTER //
// ./mobile/shared/flows/lead/reducer.js